import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

type FullScreenLoaderProps = {
    loading: boolean;
    text?: string;
    percentage?: number;
};

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ loading, text, percentage }) => {
    if (!loading) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 1300,
                width: '100vw',
                height: '100vh',
                bgcolor: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {percentage != null ? (
                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                    <CircularProgress variant="determinate" value={percentage} size="3rem" />
                    <Box
                        sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography
                            variant="caption"
                            component="div"
                            sx={{ color: 'text.secondary' }}
                        >
                            {`${Math.round(percentage)}%`}
                        </Typography>
                    </Box>
                </Box>
            ) : (
                <CircularProgress size="3rem" />
            )}

            {text && (
                <Typography sx={{ mt: 2, color: 'text.primary' }}>
                    {text}
                </Typography>
            )}
        </Box>
    );
};

export default FullScreenLoader;
